import { Component, OnInit, OnDestroy } from '@angular/core';
import { IMenuData } from './../../../interfaces/shared/menu-home.interface';
import { Country } from './../../../entities/shared/Country';
import { OptionMenuApps } from './../../../enums/shared/menu-home.enum';
import { LocalStorageService } from './../../../services/shared/local-storage/local-storage.service';
import { SessionService } from 'src/app/services/shared/session/session.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  showContainerImg:boolean=true;
  menuOption: IMenuData | null = null;
  showHtml: boolean = false;
  showSearchPerson: boolean = false;
  private destroy$ = new Subject<void>();

  get OptionMenuApps(): typeof OptionMenuApps {
    return OptionMenuApps;
  }

  constructor(
    public localStorageService: LocalStorageService,
    private sessionService: SessionService,
    private router: Router
  ) { }

  ngOnInit() {
    console.log("this.router.url ---->",this.router.url);
    const router = this.router.url;

    this.showContainerImg = router.includes('/dm/search/') && !this.localStorageService.getIsVip ? false : true;
    this.showSearchPerson = !!this.localStorageService.getRegionSeleccionada?.getCode();
    this.localStorageService.getMenuAppObs
      .pipe(takeUntil(this.destroy$))
      .subscribe((optionMenu: IMenuData) => {
        if (!optionMenu) {
          return;
        }

        // La imagen sigue visible mientras estemos en un menú (grid
        // principal o submenú de Configurador). Cualquier módulo final
        // (DM, Merge, Seguimiento de RequestID, etc.) la oculta, aunque
        // ese módulo navegue a otro componente fuera de Home.
        this.showContainerImg = optionMenu.title === OptionMenuApps.MANTENEDOR;

        // Solo DM y MANTENEDOR se renderizan dentro de Home; el resto de
        // items navegan a otro componente vía sidebar/navbar y no deben
        // tocar menuOption, o Home flashea el grid (menu-home) un frame
        // antes de ser destruido por el router.
        if (optionMenu.title !== OptionMenuApps.DM && optionMenu.title !== OptionMenuApps.MANTENEDOR) {
          return;
        }
        Promise.resolve().then(() => {
          this.menuOption = optionMenu;
        });
      });
  }

  selectCountry(paisSelecionado: Country) {
    this.sessionService.tokenPingIDValidationSession(true);
    this.localStorageService.setRegionSeleccionada = paisSelecionado;
    this.showSearchPerson = true;
    this.localStorageService.esInternoRDS = false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
